import { useMemo } from 'react';

import { useDomain } from './useDomain';

export const useFavicon = () => {
  const domain = useDomain();

  return useMemo(() => {
    if (!domain) return null;

    switch (domain) {
      case 'f3a844899bc64ed78a238c842ed9c9eec7fabd8ad6be8b6fe887649db744b3b9':
      case '2fb04eafdb32c1595afe0af7179b059c98ab3d64232dfaad6c9a7ff6c2aed93a':
        return process.env.PUBLIC_URL + '/favicon-f3a8.ico';

      case '6115212cb6b07e9e2d7c0441a16e7459375e482e494d8b09ec6bc8f4c81af946':
        return process.env.PUBLIC_URL + '/favicon-6115.ico';

      case '76d58c1500a89e24a8ae9a40b91cc2d90b08da398a0dc0262fc2123cf194884d':
        return process.env.PUBLIC_URL + '/favicon-76d5.ico';

      case '4cfc273b9a5eea63982e3e727eba9450e589c80bd8f461b29e75bb1091ea58be':
        return process.env.PUBLIC_URL + '/favicon-4cfc.ico';

      case 'd9dd32b9237bdf1ff8debc1851d16e8a4b3b6a37bd1331d8f49e3ce5ade0dd00':
        return process.env.PUBLIC_URL + '/favicon-d9dd.ico';

      case '6329d7f48d2e5685176c5cb39470f69ae0d98f3238ca66689592ba1abc9db1f8':
        return process.env.PUBLIC_URL + '/favicon-6329.ico';

      case 'b5356da461cac21801aff506a5685edbd727adf31d73cae72702d1d876f0b199':
        return process.env.PUBLIC_URL + '/favicon-b535.ico';

      case 'a6b638673ac5b7e03997bb82c967404545cc302aee3957ca53a31248cd45cd00':
        return process.env.PUBLIC_URL + '/favicon-a6b6.ico';

      case '7836b95b2a0a362c37736892fef893bfd8d9ad1d29495d2654f8632d8e544fb0':
        return process.env.PUBLIC_URL + '/favicon-7836.ico';

      default:
        return process.env.PUBLIC_URL + '/favicon-default.ico';
    }
  }, [domain]);
};
